import { useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, ScrollView } from 'react-native';
import { HouseIcon, UsersIcon, XIcon, ArticleIcon, TagIcon, CheckSquareIcon, PlantIcon, SparkleIcon, ImageIcon, BellIcon } from '@phosphor-icons/react';
import { navigate, toggleDrawer } from '../services/NavigationService';
import { EnumRoutesAppWeb } from '../enum/EnumRoutesAppWeb';
import { observer } from 'mobx-react';
import { authStore } from '../stores/AuthStore';
import { Theme } from '../enum/Theme';
import { CarrotIcon } from '@phosphor-icons/react/dist/ssr';
import SpaceH from '@comps/SpaceH';

const Menu = observer(() => {
  const [activeItem, setActiveItem] = useState(EnumRoutesAppWeb.dashboard); // Define o item ativo inicial

  const { _isLogged } = authStore
  const menuItems = [
    { label: 'Dashboard', icon: HouseIcon, route: EnumRoutesAppWeb.dashboard },
    { label: 'Usuários', icon: UsersIcon, route: EnumRoutesAppWeb.users },
    { label: 'Shopping', icon: CarrotIcon, route: EnumRoutesAppWeb.shopping },
    { label: 'Categorias do Blog', icon: TagIcon, route: EnumRoutesAppWeb.blogCategories },
    { label: 'Blog', icon: ArticleIcon, route: EnumRoutesAppWeb.blog },
    { label: 'Banners', icon: ImageIcon, route: EnumRoutesAppWeb.banners },
    { label: 'Pushes', icon: BellIcon, route: EnumRoutesAppWeb.pushes },
    { label: 'Desenvolver', icon: PlantIcon, route: EnumRoutesAppWeb.desenvolver },
    { label: ' - Atividades', icon: CheckSquareIcon, route: EnumRoutesAppWeb.activities },
    { label: ' - Extras', icon: SparkleIcon, route: EnumRoutesAppWeb.extras }
  ];

  const handleMenuItemPress = (route: any) => {
    setActiveItem(route); // Atualiza o item ativo
    navigate(route); // Navega para a rota
  };

  if (!_isLogged) return null

  return (
    <View style={styles.container}>
      <TouchableOpacity style={styles.closeBtn} onPress={() => toggleDrawer()}>
        <XIcon size={24} color={Theme.foreground} />
      </TouchableOpacity>

      <ScrollView style={{ flex: 1 }} showsVerticalScrollIndicator={false} showsHorizontalScrollIndicator={false}>
        <View style={styles.menu}>
          {menuItems.map((item, index) => (
            <TouchableOpacity
              key={index}
              style={[styles.menuItem, activeItem === item.route && styles.active]}
              onPress={() => handleMenuItemPress(item.route)}
            >
              <item.icon size={20} color={activeItem === item.route ? '#FFFFFF' : Theme.foreground} />
              <Text style={[styles.menuText, activeItem === item.route && { color: '#FFFFFF' }]}>
                {item.label}
              </Text>
            </TouchableOpacity>
          ))}
        </View>
        <SpaceH />
        <View style={styles.footer}>
          <Text style={styles.footerText}>Powered by</Text>
          <Text style={[styles.footerText, { fontWeight: 'bold' }]}>Ninno App</Text>
          <Text style={[styles.footerText, { fontSize: 10 }]}>Versão: 1.0.2</Text>
        </View>
        <SpaceH size={100} />
      </ScrollView>
    </View>
  );
})

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    backgroundColor: '#F2F2F2',
  },
  closeBtn: {
    alignSelf: 'flex-end',
    marginBottom: 30,
  },
  menu: {
    flex: 1,
  },
  menuItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 15,
    paddingHorizontal: 10,
  },
  active: {
    backgroundColor: Theme.foreground,
    borderRadius: 5,
  },
  menuText: {
    marginLeft: 15,
    fontSize: 16,
    color: Theme.foreground,
  },
  footer: {
    alignItems: 'center',
    marginBottom: 20,
  },
  footerText: {
    color: Theme.foreground,
  },
});

export default Menu